export default __webpack_public_path__ + "static/media/irl2.5ad49efb.jpg";